import { rejects } from 'assert'
import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getDevices(Subscription:number) {
  return axios.get(API_URL+'/v1/ctxr/'+Subscription+'/list')
}
export function getDevicesListglobal(Subscription:number,tenant:number) {
  return axios.get(API_URL+'/v1/ctxr/'+Subscription+'/list?tenantId='+tenant)
}
export function getpermisosDisponibles() {
  return axios.get(API_URL+'/v1/permission')
}
export function getpermisosDisponiblesGlobal(tenant:number) {
  return axios.get(API_URL+'/v1/permission?tenantId='+tenant)
}
export function getNeigborId(uuid:any,id:any) {
    return axios.get(API_URL+'/v1/ctxr/configbgpneighbor/'+uuid+'/'+id)
  }
export function getNeigborIdGlobal(uuid:any,id:any,tenant:number) {
    return axios.get(API_URL+'/v1/ctxr/configbgpneighbor/'+uuid+'/'+id+'?tenantId='+tenant)
  }
export function getroles() {
    return axios.get(API_URL+'/v1/rol/')
  }

export function getips(uuid:any) {
    return axios.get(API_URL+'/v1/ctxr/listcni/'+uuid)
  }
export function getipstenant(uuid:any,tenant:number) {
    return axios.get(API_URL+'/v1/ctxr/listcni/'+uuid+'?tenantId='+tenant)
  }

export function getListServerLogs(Subscription:number, page:number, size:number, tenantId:number | undefined) {
  let params = {
    page: page ,
    limit: size, 
  }
  if(tenantId !== 0 && tenantId !== undefined ){
    Object.assign(params, { tenantId: tenantId });
  }

  return axios.get(API_URL+'/v1/serverlog/'+Subscription+'/', { params: params })
}

export function getOneServerLog(Subscription:number, id: number ,tenantId:number | undefined) {
  let params = {}
  if(tenantId !== 0 && tenantId !== undefined ){
    Object.assign(params, { tenantId: tenantId });
  }

  return axios.get(API_URL+'/v1/serverlog/'+Subscription+'/'+id, { params: params })
}

export async function createOneServerLog(Subscription:number, body:any ,tenantId:number | undefined) {
  let params = {}
  if(tenantId !== 0 && tenantId !== undefined ){
    Object.assign(params, { tenantId: tenantId });
  }
  const response =  await axios.post(API_URL+'/v1/serverlog/'+Subscription+'/', body , { params: params })
  return response;
}

export function UpdateOneServerLog(Subscription:number, id:number,  body:any ,tenantId:number | undefined) {
  let params = {}
  if(tenantId !== 0 && tenantId !== undefined ){
    Object.assign(params, { tenantId: tenantId });
  }

  return axios.put(API_URL+'/v1/serverlog/'+Subscription+'/'+id, body , { params: params })
}

export function deleteOneServerLog(Subscription:number, id:number ,tenantId:number | undefined) {
  let params = {}
  if(tenantId !== 0 && tenantId !== undefined ){
    Object.assign(params, { tenantId: tenantId });
  }

  return axios.delete(API_URL+'/v1/serverlog/'+Subscription+'/'+id,  { params: params })
}